import {
    CLOSE_LOADER,
    SET_ERROR,
    SET_LOADER,
    SET_SUCCESS,
  } from "../Types/AuthTypes";
import { SET_CASH_PAYMENT, SET_SPECIFIC_CASH_PAYMENT, RESET_SPECIFIC_PAYMENT } from "../Types/CashPaymentTypes";
  import backendVerifiedUser from "../../api/backendVerifiedUser";
  
  export const addCashPayment = (data) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.post(
          "/add-cash-receipt-payment",
          data
        );
        dispatch({ type: CLOSE_LOADER });
        console.log(data)
        dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
  
        return true;
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
        return false;
      }
    };
  };
  
  export const getCashPayment = () => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.get("/get-cash-receipt-payment");
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_CASH_PAYMENT, payLoad: response.data });
  
        return true;
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
        return false;
      }
    };
  };

  export const getSpecificCashPayment = (id) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.get(
          `/get-specfic-cash-payment/${id}`
        );
        console.log("response ------>", response);
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_SPECIFIC_CASH_PAYMENT, payLoad: response.data });
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
      }
    };
  };

  export const updateCashPayment = (data, id) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.post(
          `/update-cash-payment/${id}`,
          data
        );
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
        dispatch({ type: RESET_SPECIFIC_PAYMENT });
        return true;
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
      }
    };
  };
  


  